export default "/public/img/logoRightEn-c7509553731b5ea38d012d16617adf75.png";